module.exports = __webpack_public_path__ + "media/images/chara-right-e7bf4fa3096d5c964215b40162534f2f.png";